var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVideoPanelIcon = function SvgVideoPanelIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 69,
    height: 52,
    fill: "none",
    viewBox: "0 0 69 52"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 67,
    height: 51,
    x: 1,
    y: 0.5,
    stroke: "#3D4355",
    rx: 9.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E5E5FE",
    stroke: "#3D4355",
    d: "M44.547 23.991c1.937 1.1 1.937 3.918 0 5.018l-14.305 8.118C28.351 38.2 26 36.825 26 34.617V18.383c0-2.207 2.35-3.582 4.242-2.509z"
  })));
};
export default SvgVideoPanelIcon;